import { FormikProps } from 'formik';

type AbsenceTypesDesProps = {
  setCheckFlag: (data) => void;
  checkFlag?: boolean;
  formik?: FormikProps<any>;
  isDetail?: boolean;
};

const AbsenceTypesDes = ({
  checkFlag,
  setCheckFlag,
  formik,
  isDetail = false,
}: AbsenceTypesDesProps) => {
  const handleClick = () => {
    if (!isDetail) {
      setCheckFlag(!checkFlag);
    }
  };
  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginTop: 20, paddingLeft: 15 }}>
        <div
          style={{
            width: '19%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img src="/assets/eng.svg" alt="flag" />
        </div>
        <input
          maxLength={50}
          name="description"
          onChange={formik?.handleChange}
          disabled={isDetail}
          value={formik.values?.description}
          style={{
            width: '19.5%',
            background: isDetail ? '#f5f5f5' : '',
            border: isDetail && 'none',
          }}
          className="common_custom_input_search"
        />
        <input
          maxLength={60}
          name="long_description"
          onChange={formik?.handleChange}
          disabled={isDetail}
          value={formik.values?.long_description}
          style={{
            width: '19.5%',
            background: isDetail ? '#f5f5f5' : '',
            border: isDetail && 'none',
          }}
          className="common_custom_input_search"
        />
        <input
          maxLength={50}
          name="comment"
          onChange={formik?.handleChange}
          disabled={isDetail}
          value={formik.values?.comment}
          style={{
            width: '20%',
            background: isDetail ? '#f5f5f5' : '',
            border: isDetail && 'none',
          }}
          className="common_custom_input_search"
        />
        <div
          style={{
            width: '19%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <img onClick={handleClick} src="/assets/flag_fill.svg" alt="flag" />
        </div>
      </div>
      {checkFlag && (
        <div
          style={{ display: 'flex', gap: 10, marginTop: 20, paddingLeft: 15 }}
        >
          <div
            style={{
              width: '19%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src="/icons/france.svg" alt="flag" />
          </div>
          <input
            maxLength={50}
            disabled={formik?.values?.length > 0}
            name="french_description"
            style={{
              width: '19.5%',
              background: isDetail ? '#f5f5f5' : '',
              border: isDetail && 'none',
            }}
            value={formik.values?.french_description}
            onChange={formik.handleChange}
            className="common_custom_input_search"
          />
          <input
            maxLength={60}
            disabled={formik?.values.length > 0}
            style={{
              width: '19.5%',
              background: isDetail ? '#f5f5f5' : '',
              border: isDetail && 'none',
            }}
            name="french_long_description"
            value={formik.values?.french_long_description}
            onChange={formik.handleChange}
            className="common_custom_input_search"
          />
          <input
            maxLength={50}
            disabled={isDetail}
            style={{
              width: '20%',
              background: isDetail ? '#f5f5f5' : '',
              border: isDetail && 'none',
            }}
            name="french_comment"
            value={formik.values?.french_comment}
            onChange={formik.handleChange}
            className="common_custom_input_search"
          />
          <div
            style={{
              width: '19%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <img src="/assets/flag_fill.svg" alt="flag" />
          </div>
        </div>
      )}
    </div>
  );
};

export default AbsenceTypesDes;
